/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API20848Req {
  
  /** 模块id */
  moduleId?: string;
  /** 菜单相对路径 */
  menuPath?: string;
  /** 搜索内容 */
  searchContent?: string;
};



export interface API20848Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 20848 锁定用户模块

export interface IUsePostAPI20848Return {
  /** 锁定用户模块: 接口请求状态 */
  isAPI20848Loading: boolean;
  /** 锁定用户模块: 接口请求返回数据 */
  dataAPI20848: API20848Res;
  /**  锁定用户模块: 接口数据请求方法 */
  fetchAPI20848Data:  (inputs: API20848Req, config?: YWRequestConfig) => Promise<API20848Res>;
  /** 锁定用户模块: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI20848 = ():IUsePostAPI20848Return => {
  let isMount = true;
  const [isAPI20848Loading, setIsAPI20848Loading] = useState(false);
  const [dataAPI20848, setDataAPI20848] = useState<API20848Res>({} as API20848Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/cloud/lock/module`;

  const fetchAPI20848Data = async (inputs: API20848Req, config?: YWRequestConfig): Promise<API20848Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20848Req>) || {}) as API20848Req;
    
  
    if ( isMount ) {
      setIsAPI20848Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API20848Res>(`${basePath}/ywwl-admin/desktop/cloud/lock/module`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI20848(res || {} as API20848Res);
        setIsAPI20848Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20848Loading(false);
      }
      return false as unknown as API20848Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20848Loading,
    dataAPI20848,
    fetchAPI20848Data,
    requestUrl,
  }
}

